export default __webpack_public_path__ + "static/media/img-slider-tspace-1.dff7605f.png";